import { render } from "./HorizontalHeader.vue?vue&type=template&id=16157450&scoped=true"
import script from "./HorizontalHeader.vue?vue&type=script&lang=js"
export * from "./HorizontalHeader.vue?vue&type=script&lang=js"

import "./HorizontalHeader.vue?vue&type=style&index=0&id=16157450&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16157450"]])

export default __exports__